import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { PersonDTO } from '@auto-generated/ap-platform/care-providers';

@Component({
	selector: 'ap-provider-profile-status',
	templateUrl: './provider-profile-status.component.html',
	styles: [`
        ap-provider-profile-status {
            display: flex;
        }

        ap-provider-profile-status .mat-icon {
            display: flex;
            justify-content: center;
            align-items: center;
        }
	`],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderProfileStatusComponent {

	@Input() public provider: PersonDTO;

	constructor() {
	}
}
